import { render, staticRenderFns } from "./UninvoicedStockCorrectionsPage.vue?vue&type=template&id=1516ac4a&scoped=true&"
import script from "./UninvoicedStockCorrectionsPage.vue?vue&type=script&lang=ts&"
export * from "./UninvoicedStockCorrectionsPage.vue?vue&type=script&lang=ts&"
import style0 from "./UninvoicedStockCorrectionsPage.vue?vue&type=style&index=0&id=1516ac4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1516ac4a",
  null
  
)

export default component.exports